interface QuickWinBoltProps {
  className?: string
  fillClassName?: string
  width?: number
  height?: number
  fill?: string
  innerFill?: string
  strokeWidth?: number
  style?: React.CSSProperties
}

export const QuickWinBolt = ({
  className,
  fillClassName,
  width = 9,
  height = 11,
  fill = "currentColor",
  innerFill,
  strokeWidth,
  style
}: QuickWinBoltProps) => (
  <svg
    viewBox="0 0 8.62 10.42"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    style={style}
    aria-hidden="true"
  >
    <path
      d="M8.517 3.302H5.754L8.239.163A.1.1 0 0 0 8.16 0H3.35a.1.1 0 0 0-.087.05L.014 5.662a.1.1 0 0 0 .086.151H2.288L1.166 10.298c-.023.098.095.167.167.097L8.586 3.474a.1.1 0 0 0-.069-.172ZM2.625 7.983l.756-3.023H1.407L3.785.854h2.817L3.99 4.156h2.646L2.625 7.983Z"
      fill={fill}
    />
    <path
      className={fillClassName}
      d="M2.625 7.983l.756-3.023H1.407L3.785.854h2.817L3.99 4.156h2.646L2.625 7.983Z"
      fill={innerFill ?? fill}
      stroke={strokeWidth ? fill : undefined}
      strokeWidth={strokeWidth}
      strokeLinejoin="round"
    />
  </svg>
)
